import { Fragment } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { renderIcon } from '@opallabs/kuiper'
import { CharacterCounterMethod } from '@opallabs/text-editor'
import { AccountName } from '../../../../../AccountName'
import { ContentAvatar } from '../../../../../ContentAvatar'
import { ContentTextInput } from '../../../../../ContentTextInput'
import { sharedStyles, sharedColors } from '../../sharedStyles/styles'
import { styles } from './styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  isAccountPremium?: boolean
  isMobile: boolean
  onContentChange: (val: string) => void
  readOnly: boolean
}

export const TwitterSingleHeader: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  isAccountPremium,
  isMobile,
  onContentChange,
  readOnly,
}) => {
  const characterLimit = isAccountPremium ? 25_000 : 280
  const caretIcon = isMobile ? 'twitter-mobile-caret' : 'twitter-desktop-caret'

  return (
    <Fragment>
      <div css={styles.getAccountHeaderWrapper(isMobile)}>
        <div css={sharedStyles.flexRow}>
          <ContentAvatar assetReference={accountImage} size={49} />
          <div css={sharedStyles.flexColumn}>
            <AccountName
              name={accountName}
              size={15}
              color={sharedColors.darkGreyText}
              style={styles.getAccountName(isMobile)}
            />
            {accountUsername && (
              <AccountName
                accountHandle="@"
                name={accountUsername}
                size={15}
                style={sharedStyles.getAccountUsername(false)}
              />
            )}
          </div>
        </div>
        <div css={sharedStyles.getTwitterCaretWrapper(isMobile)}>
          {renderIcon(caretIcon, { height: 6, width: 11, ariaMode: 'hidden' })}
        </div>
      </div>
      <ContentTextInput
        key={characterLimit}
        characterLimit={characterLimit}
        characterCounterOptions={{
          counterMethod: CharacterCounterMethod.TwitterX,
        }}
        placeholder="What's happening?"
        readOnly={readOnly}
        value={content}
        highlightSocialTags={true}
        onChange={onContentChange}
        style={styles.getContentWrapper(isMobile)}
      />
    </Fragment>
  )
}
